import React from "react";
import { Loader2 } from "lucide-react";
import "./B2BLoadingSpinner.css";

interface B2BLoadingSpinnerProps {
  size?: "small" | "medium" | "large";
  text?: string;
  className?: string;
  inline?: boolean;
}

/**
 * Reusable loading spinner component for B2B flows
 * Provides consistent loading states across components
 */
const B2BLoadingSpinner: React.FC<B2BLoadingSpinnerProps> = ({
  size = "medium",
  text = "",
  className = "",
  inline = false,
}) => {
  const sizeClasses = {
    small: "b2b-spinner-small",
    medium: "b2b-spinner-medium",
    large: "b2b-spinner-large",
  };

  const containerClass = inline
    ? "b2b-spinner-inline"
    : "b2b-spinner-container";

  return (
    <div className={`${containerClass} ${className}`}>
      <Loader2
        className={`b2b-spinner ${sizeClasses[size]} b2b-spinner-animate`}
      />
      {text && <p className="b2b-spinner-text">{text}</p>}
    </div>
  );
};

export default B2BLoadingSpinner;

